import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBUkUPjZ3FMvMTpYwV6uUVOA4mG7rsjttg",
  authDomain: "auto-aba9d.firebaseapp.com",
  projectId: "auto-aba9d",
  storageBucket: "auto-aba9d.firebasestorage.app",
  messagingSenderId: "824452569705",
  appId: "1:824452569705:web:b8011b53397a8ebc51e0f8"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

enableIndexedDbPersistence(db).catch((err) => {
  if (err?.code === "failed-precondition") {
    console.warn("Firestore persistence skipped: multiple tabs open.");
  } else if (err?.code === "unimplemented") {
    console.warn("Firestore persistence not supported in this browser.");
  } else {
    console.warn("Firestore persistence error:", err);
  }
});

export default app;